export const getCountryName = (countryId) => {
  if (!countryId) return ""
  const country = countryCodes.find((c) => c.value === countryId)
  if (country) return country.label
  return ""
}

export const getCountryNameByCode = (countryCode) => {
  if (!countryCode) return ""
  const country = countryCodes.find((c) => c.code === countryCode)
  if (country) return country.label
  return ""
}

export const getCountryID = (countryCode) => {
  if (!countryCode) return ""
  const country = countryCodes.find((c) => c.code === countryCode)
  if (country) return country.value
  return ""
}

export const countryCodes = [
  { value: "293", label: "Denmark", code: "DK" },
  { value: "434", label: "Sweden", code: "SE" },
  { value: "2", label: "United Kingdom", code: "GB" },
  { value: "237", label: "Albania", code: "AL" },
  { value: "238", label: "Algeria", code: "DZ" },
  { value: "239", label: "American Samoa" },
  { value: "240", label: "Andorra", code: "AD" },
  { value: "241", label: "Angola", code: "AO" },
  { value: "242", label: "Anguilla", code: "AI" },
  { value: "243", label: "Antigua and Barbuda", code: "AG" },
  { value: "244", label: "Argentina", code: "AR" },
  { value: "245", label: "Armenia", code: "AM" },
  { value: "246", label: "Aruba", code: "AW" },
  { value: "247", label: "Australia", code: "AU" },
  { value: "248", label: "Austria", code: "AT" },
  { value: "249", label: "Azerbaijan", code: "AZ" },
  { value: "250", label: "Bahamas", code: "BS" },
  { value: "251", label: "Bahrain", code: "BH" },
  { value: "252", label: "Bangladesh", code: "BD" },
  { value: "253", label: "Barbados", code: "BB" },
  { value: "254", label: "Belarus", code: "BY" },
  { value: "255", label: "Belgium", code: "BE" },
  { value: "256", label: "Belize", code: "BZ" },
  { value: "257", label: "Benin", code: "BJ" },
  { value: "258", label: "Bermuda", code: "BM" },
  { value: "259", label: "Bhutan", code: "BT" },
  { value: "260", label: "Bolivia" },
  { value: "261", label: "Bosnia and Herzegovina", code: "BA" },
  { value: "262", label: "Botswana", code: "BW" },
  { value: "263", label: "Bouvet Island" },
  { value: "264", label: "Brazil", code: "BR" },
  { value: "265", label: "British Virgin Islands" },
  { value: "266", label: "British Indian Ocean Territory", code: "IO" },
  { value: "267", label: "Brunei Darussalam", code: "BN" },
  { value: "268", label: "Bulgaria", code: "BG" },
  { value: "269", label: "Burkina Faso", code: "BF" },
  { value: "270", label: "Burundi", code: "BI" },
  { value: "271", label: "Cambodia", code: "KH" },
  { value: "272", label: "Cameroon", code: "CM" },
  { value: "273", label: "Canada", code: "CA" },
  { value: "274", label: "Cape Verde", code: "CV" },
  { value: "275", label: "Cayman Islands", code: "KY" },
  { value: "276", label: "Central African Republic", code: "CF" },
  { value: "277", label: "Chad", code: "TD" },
  { value: "278", label: "Chile", code: "CL" },
  { value: "279", label: "China", code: "CN" },
  { value: "280", label: "Christmas Island", code: "CX" },
  { value: "281", label: "Cocos (Keeling) Islands", code: "CC" },
  { value: "282", label: "Colombia", code: "CO" },
  { value: "283", label: "Comoros", code: "KM" },
  { value: "284", label: "Congo (Brazzaville)" },
  { value: "285", label: "Congo, Democratic Republic of the" },
  { value: "286", label: "Cook Islands", code: "CK" },
  { value: "287", label: "Costa Rica", code: "CR" },
  { value: "288", label: "Côte d'Ivoire" },
  { value: "289", label: "Croatia", code: "HR" },
  { value: "290", label: "Cuba", code: "CU" },
  { value: "291", label: "Cyprus", code: "CY" },
  { value: "292", label: "Czech Republic", code: "CZ" },
  { value: "294", label: "Djibouti", code: "DJ" },
  { value: "295", label: "Dominica", code: "DM" },
  { value: "296", label: "Dominican Republic", code: "DO" },
  { value: "297", label: "Ecuador", code: "EC" },
  { value: "298", label: "Egypt", code: "EG" },
  { value: "299", label: "El Salvador", code: "SV" },
  { value: "300", label: "Equatorial Guinea", code: "GQ" },
  { value: "301", label: "Eritrea", code: "ER" },
  { value: "302", label: "Estonia", code: "EE" },
  { value: "303", label: "Ethiopia", code: "ET" },
  { value: "304", label: "Falkland Islands (Malvinas)", code: "FK" },
  { value: "305", label: "Faroe Islands", code: "FO" },
  { value: "306", label: "Fiji", code: "FJ" },
  { value: "307", label: "Finland", code: "FI" },
  { value: "308", label: "France", code: "FR" },
  { value: "309", label: "French Guiana", code: "GF" },
  { value: "310", label: "French Polynesia", code: "PF" },
  { value: "311", label: "French Southern Territories" },
  { value: "312", label: "Gabon", code: "GA" },
  { value: "313", label: "Gambia", code: "GM" },
  { value: "314", label: "Georgia", code: "GE" },
  { value: "315", label: "Germany", code: "DE" },
  { value: "316", label: "Ghana", code: "GH" },
  { value: "317", label: "Gibraltar", code: "GI" },
  { value: "318", label: "Greece", code: "GR" },
  { value: "319", label: "Greenland", code: "GL" },
  { value: "320", label: "Grenada", code: "GD" },
  { value: "321", label: "Guadeloupe", code: "GP" },
  { value: "322", label: "Guam", code: "GU" },
  { value: "323", label: "Guatemala", code: "GT" },
  { value: "324", label: "Guernsey", code: "GG" },
  { value: "325", label: "Guinea", code: "GN" },
  { value: "326", label: "Guinea-Bissau", code: "GW" },
  { value: "327", label: "Guyana", code: "GY" },
  { value: "328", label: "Haiti", code: "HT" },
  { value: "329", label: "Honduras", code: "HN" },
  { value: "330", label: "Hungary", code: "HU" },
  { value: "331", label: "Iceland", code: "IS" },
  { value: "332", label: "India", code: "IN" },
  { value: "333", label: "Indonesia", code: "ID" },
  { value: "334", label: "Iran, Islamic Republic of" },
  { value: "335", label: "Iraq", code: "IQ" },
  { value: "336", label: "Ireland", code: "IE" },
  { value: "337", label: "Isle of Man", code: "IM" },
  { value: "338", label: "Israel", code: "IL" },
  { value: "339", label: "Italy", code: "IT" },
  { value: "340", label: "Jamaica", code: "JM" },
  { value: "341", label: "Japan", code: "JP" },
  { value: "342", label: "Jersey", code: "JE" },
  { value: "343", label: "Jordan", code: "JO" },
  { value: "344", label: "Kazakhstan", code: "KZ" },
  { value: "345", label: "Kenya", code: "KE" },
  { value: "346", label: "Kiribati", code: "KI" },
  { value: "347", label: "Korea, Democratic People's Republic of" },
  { value: "348", label: "Korea, Republic of" },
  { value: "349", label: "Kuwait", code: "KW" },
  { value: "350", label: "Kyrgyzstan", code: "KG" },
  { value: "351", label: "Lao PDR" },
  { value: "352", label: "Latvia", code: "LV" },
  { value: "353", label: "Lebanon", code: "LB" },
  { value: "354", label: "Liberia", code: "LR" },
  { value: "355", label: "Libyan Arab Jamahiriya", code: "LY" },
  { value: "356", label: "Liechtenstein", code: "LI" },
  { value: "357", label: "Lithuania", code: "LT" },
  { value: "358", label: "Luxembourg", code: "LU" },
  { value: "359", label: "Macedonia, Republic of" },
  { value: "360", label: "Madagascar", code: "MG" },
  { value: "361", label: "Malawi", code: "MW" },
  { value: "362", label: "Malaysia", code: "MY" },
  { value: "363", label: "Maldives", code: "MV" },
  { value: "364", label: "Mali", code: "ML" },
  { value: "365", label: "Malta", code: "MT" },
  { value: "366", label: "Marshall Islands", code: "MH" },
  { value: "367", label: "Martinique", code: "MQ" },
  { value: "368", label: "Mauritania", code: "MR" },
  { value: "369", label: "Mauritius", code: "MU" },
  { value: "370", label: "Mayotte", code: "YT" },
  { value: "371", label: "Mexico", code: "MX" },
  { value: "372", label: "Micronesia, Federated States of" },
  { value: "373", label: "Moldova", code: "MD" },
  { value: "374", label: "Monaco", code: "MC" },
  { value: "375", label: "Mongolia", code: "MN" },
  { value: "376", label: "Montenegro", code: "ME" },
  { value: "377", label: "Montserrat", code: "MS" },
  { value: "378", label: "Morocco", code: "MA" },
  { value: "379", label: "Mozambique", code: "MZ" },
  { value: "380", label: "Myanmar", code: "MM" },
  { value: "381", label: "Namibia", code: "NA" },
  { value: "382", label: "Nauru", code: "NR" },
  { value: "383", label: "Nepal", code: "NP" },
  { value: "384", label: "Netherlands", code: "NL" },
  { value: "385", label: "Netherlands Antilles", code: "AN" },
  { value: "386", label: "New Caledonia", code: "NC" },
  { value: "387", label: "New Zealand", code: "NZ" },
  { value: "388", label: "Nicaragua", code: "NI" },
  { value: "389", label: "Niger", code: "NE" },
  { value: "390", label: "Nigeria", code: "NG" },
  { value: "391", label: "Niue", code: "NU" },
  { value: "392", label: "Norfolk Island", code: "NF" },
  { value: "393", label: "Northern Mariana Islands", code: "MP" },
  { value: "394", label: "Norway", code: "NO" },
  { value: "395", label: "Oman", code: "OM" },
  { value: "396", label: "Pakistan", code: "PK" },
  { value: "397", label: "Palau", code: "PW" },
  { value: "398", label: "Panama", code: "PA" },
  { value: "399", label: "Papua New Guinea", code: "PG" },
  { value: "400", label: "Paraguay", code: "PY" },
  { value: "401", label: "Peru", code: "PE" },
  { value: "402", label: "Philippines", code: "PH" },
  { value: "403", label: "Pitcairn", code: "PN" },
  { value: "404", label: "Poland", code: "PL" },
  { value: "405", label: "Portugal", code: "PT" },
  { value: "406", label: "Puerto Rico", code: "PR" },
  { value: "407", label: "Qatar", code: "QA" },
  { value: "408", label: "Réunion" },
  { value: "409", label: "Romania", code: "RO" },
  { value: "410", label: "Russian Federation" },
  { value: "411", label: "Rwanda", code: "RW" },
  { value: "412", label: "Saint Helena" },
  { value: "413", label: "Saint Kitts and Nevis", code: "KN" },
  { value: "414", label: "Saint Lucia", code: "LC" },
  { value: "415", label: "Samoa", code: "WS" },
  { value: "416", label: "San Marino", code: "SM" },
  { value: "417", label: "Sao Tome and Principe", code: "ST" },
  { value: "418", label: "Saudi Arabia", code: "SA" },
  { value: "419", label: "Senegal", code: "SN" },
  { value: "420", label: "Serbia", code: "RS" },
  { value: "421", label: "Seychelles", code: "SC" },
  { value: "422", label: "Sierra Leone", code: "SL" },
  { value: "423", label: "Singapore", code: "SG" },
  { value: "424", label: "Slovakia", code: "SK" },
  { value: "425", label: "Slovenia", code: "SI" },
  { value: "426", label: "Solomon Islands", code: "SB" },
  { value: "427", label: "Somalia", code: "SO" },
  { value: "428", label: "South Africa", code: "ZA" },
  { value: "429", label: "Spain", code: "ES" },
  { value: "430", label: "Sri Lanka", code: "LK" },
  { value: "431", label: "Sudan", code: "SD" },
  { value: "432", label: "Suriname *" },
  { value: "433", label: "Swaziland", code: "SZ" },
  { value: "435", label: "Switzerland", code: "CH" },
  { value: "436", label: "Syrian Arab Republic", code: "SY" },
  { value: "437", label: "Taiwan, Republic of China" },
  { value: "438", label: "Tajikistan", code: "TJ" },
  { value: "439", label: "Tanzania *, United Republic of" },
  { value: "440", label: "Thailand", code: "TH" },
  { value: "441", label: "Timor-Leste", code: "TL" },
  { value: "442", label: "Togo", code: "TG" },
  { value: "443", label: "Tokelau", code: "TK" },
  { value: "444", label: "Tonga", code: "TO" },
  { value: "445", label: "Trinidad and Tobago", code: "TT" },
  { value: "446", label: "Tunisia", code: "TN" },
  { value: "447", label: "Turkey", code: "TR" },
  { value: "448", label: "Turkmenistan", code: "TM" },
  { value: "449", label: "Turks and Caicos Islands", code: "TC" },
  { value: "450", label: "Tuvalu", code: "TV" },
  { value: "451", label: "Uganda", code: "UG" },
  { value: "452", label: "Ukraine", code: "UA" },
  { value: "453", label: "United Arab Emirates", code: "AE" },
  { value: "454", label: "United States of America" },
  { value: "455", label: "United States Minor Outlying Islands" },
  { value: "456", label: "Uruguay", code: "UY" },
  { value: "457", label: "Uzbekistan", code: "UZ" },
  { value: "458", label: "Vanuatu", code: "VU" },
  { value: "459", label: "Venezuela (Bolivarian Republic of)" },
  { value: "460", label: "Viet Nam" },
  { value: "461", label: "Virgin Islands, US" },
  { value: "462", label: "Wallis and Futuna Islands" },
  { value: "463", label: "Western Sahara" },
  { value: "464", label: "Yemen", code: "YE" },
  { value: "465", label: "Zambia", code: "ZM" },
  { value: "466", label: "Zimbabwe", code: "ZW" },
]
